export default __webpack_public_path__ + "imgs/020e9fc4d5681cc6fd02cab2ce3e453a.png";